import { render, staticRenderFns } from "./SortPopup.vue?vue&type=template&id=ced2a6f8"
import script from "./SortPopup.vue?vue&type=script&lang=js"
export * from "./SortPopup.vue?vue&type=script&lang=js"
import style0 from "./SortPopup.vue?vue&type=style&index=0&id=ced2a6f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports